import type { LucideIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import styles from './OverviewStat.module.css';

interface OverviewStatProps {
  label: string;
  value: string;
  hint: string;
  to: string;
  icon: LucideIcon;
  tone?: 'success' | 'warning' | 'danger' | 'info';
}

export function OverviewStat({ label, value, hint, to, icon: Icon, tone = 'info' }: OverviewStatProps) {
  const content = (
    <div className={styles.stat} data-tone={tone}>
      <div className={styles.content}>
        <span className={styles.label}>{label}</span>
        <strong className={styles.value}>{value}</strong>
        <span className={styles.hint}>{hint}</span>
      </div>
      <Icon className={styles.icon} size={20} aria-hidden="true" />
    </div>
  );
  const ariaLabel = `${label}: ${value}. ${hint}`;

  if (to.startsWith('#')) {
    return <a className={styles.link} href={to} aria-label={ariaLabel}>{content}</a>;
  }

  return (
    <Link className={styles.link} to={to} aria-label={ariaLabel}>
      {content}
    </Link>
  );
}
